import React from 'react';
import styled from 'styled-components';
import { TextAlignment } from '../../enum/EnumRepository';
import { StyledTextAreaComponent } from '../../dto/StyleCompRepository';
import { getPageMessage } from '../../constants/pageMessages';
import { useStandardAlertStore } from '../../store/portal/alertStore';
import HeadlessTextArea from '../headless/textarea/HeadlessTextArea';

interface MoleculeTextareaDescriptionForModalProps {
  value: string;
  handleChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  StyledTextarea: StyledTextAreaComponent;
  alignment?: TextAlignment;
  placeholder?: string;
  maxLength?: number;
  maxRows?: number;
}

const MoleculeTextareaDescriptionForModal: React.FC<MoleculeTextareaDescriptionForModalProps> = ({
  value,
  handleChange,
  StyledTextarea,
  alignment,
  placeholder,
  maxLength,
  maxRows
}) => {
  const { setTextLengthExceededAlert } = useStandardAlertStore();

  const handleChangeWithLimit = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (maxLength && e.target.value.length > maxLength) {
      setTextLengthExceededAlert(maxLength);
      return;
    }
    handleChange(e);
  };

  return (
    <HeadlessTextAreaWrapper>
      {maxLength && (
        <LimitDiv>
          {value.toString().length} / {maxLength}
        </LimitDiv>
      )}
      <HeadlessTextArea
        alignment={alignment ? alignment : TextAlignment.LEFT}
        content={value}
        placeholder={placeholder ? placeholder : getPageMessage('DESCRIPTION_PLACEHOLDER_DEFAULT')}
        handleChange={maxLength ? handleChangeWithLimit : handleChange}
        StyledTextArea={StyledTextarea}
        $maxRows={maxRows}
      />
    </HeadlessTextAreaWrapper>
  );
};

const HeadlessTextAreaWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const LimitDiv = styled.div`
  position: absolute;
  top: -8px;
  right: 0;
  color: ${({ theme }) => theme.colors.color_Gray_05};
  ${({ theme }) => theme.typography.Body_04};
  user-select: none;
  z-index: 2;
`;

export default MoleculeTextareaDescriptionForModal;
